// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Tooltip_tooltipWrapper__spXhD","tooltip":"Tooltip_tooltip__v+27B"};